// src/data/sizes.js
export const sizes = {
  fan: {
    label: "Torcedor",
    icon: "👕",
    data: [
      {
        size: "P",
        comprimento: [69, 71],
        largura: [53, 55],
        altura: [162, 170],
        peso: [50, 62],
      },
      {
        size: "M",
        comprimento: [71, 73],
        largura: [55, 57],
        altura: [170, 176],
        peso: [62, 78],
      },
      {
        size: "G",
        comprimento: [73, 75],
        largura: [57, 58],
        altura: [176, 182],
        peso: [78, 83],
      },
      {
        size: "GG",
        comprimento: [75, 78],
        largura: [58, 60],
        altura: [182, 190],
        peso: [83, 90],
      },
      {
        size: "2XL",
        comprimento: [78, 81],
        largura: [60, 62],
        altura: [190, 195],
        peso: [90, 97],
      },
      {
        size: "3XL",
        comprimento: [81, 83],
        largura: [62, 64],
        altura: [192, 197],
        peso: [97, 104],
      },
    ],
  },
  player: {
    label: "Jogador",
    icon: "🧍‍♂️",
    data: [
      {
        size: "P",
        comprimento: [67, 69],
        largura: [49, 51],
        altura: [162, 170],
        peso: [50, 62],
      },
      {
        size: "M",
        comprimento: [69, 71],
        largura: [51, 53],
        altura: [170, 175],
        peso: [62, 75],
      },
      {
        size: "G",
        comprimento: [71, 73],
        largura: [53, 55],
        altura: [175, 180],
        peso: [75, 80],
      },
      {
        size: "GG",
        comprimento: [73, 76],
        largura: [55, 57],
        altura: [180, 185],
        peso: [80, 85],
      },
      {
        size: "2XL",
        comprimento: [76, 78],
        largura: [57, 60],
        altura: [185, 190],
        peso: [85, 90],
      },
      {
        size: "3XL",
        comprimento: [78, 79],
        largura: [60, 63],
        altura: [190, 195],
        peso: [90, 95],
      },
    ],
  },
  feminina: {
    label: "Feminina",
    icon: "👩",
    data: [
      {
        size: "P",
        comprimento: [61, 63],
        largura: [40, 41],
        altura: [150, 160],
      },
      {
        size: "M",
        comprimento: [63, 66],
        largura: [41, 44],
        altura: [160, 165],
      },
      {
        size: "G",
        comprimento: [66, 69],
        largura: [44, 47],
        altura: [165, 170],
      },
      {
        size: "GG",
        comprimento: [69, 71],
        largura: [47, 50],
        altura: [170, 175],
      },
    ],
  },
  infantil: {
    label: "Infantil",
    icon: "🧒",
    data: [
      {
        size: "14",
        idade: "2-3",
        altura: [85, 95],
        comprimento: [41, 44],
        largura: [33, 35],
        cintura: [19, 36],
      },
      {
        size: "16",
        idade: "3-4",
        altura: [95, 105],
        comprimento: [44, 47],
        largura: [35, 37],
        cintura: [20, 37],
      },
      {
        size: "18",
        idade: "4-5",
        altura: [105, 115],
        comprimento: [47, 50],
        largura: [37, 39],
        cintura: [21, 39],
      },
      {
        size: "20",
        idade: "5-6",
        altura: [115, 125],
        comprimento: [50, 53],
        largura: [39, 41],
        cintura: [22, 41],
      },
      {
        size: "22",
        idade: "6-7",
        altura: [125, 135],
        comprimento: [53, 56],
        largura: [41, 43],
        cintura: [23, 42],
      },
      {
        size: "24",
        idade: "8-9",
        altura: [135, 145],
        comprimento: [56, 59],
        largura: [43, 45],
        cintura: [24, 44],
      },
      {
        size: "26",
        idade: "10-11",
        altura: [145, 155],
        comprimento: [59, 62],
        largura: [45, 47],
        cintura: [25, 47],
      },
      {
        size: "28",
        idade: "12-13",
        altura: [155, 165],
        comprimento: [62, 65],
        largura: [47, 49],
        cintura: [26, 50],
      },
    ],
  },
  polo: {
    label: "Camisa Polo",
    icon: "👔",
    data: [
      {
        size: "P",
        largura: [48, 48],
        comprimento: [70, 70],
        manga: [34.5, 34.5],
        altura: [160, 170],
        peso: [60, 65],
      },
      {
        size: "M",
        largura: [50, 50],
        comprimento: [72, 72],
        manga: [36, 36],
        altura: [165, 175],
        peso: [65, 70],
      },
      {
        size: "G",
        largura: [52, 52],
        comprimento: [74, 74],
        manga: [37.5, 37.5],
        altura: [175, 180],
        peso: [70, 75],
      },
      {
        size: "GG",
        largura: [54, 54],
        comprimento: [76, 76],
        manga: [39, 39],
        altura: [180, 185],
        peso: [75, 80],
      },
    ],
  },
  retro: {
    label: "Camisa Retrô",
    icon: "🟥",
    data: [
      {
        size: "P",
        largura: [48, 48],
        comprimento: [67, 67],
        altura: [160, 165],
      },
      {
        size: "M",
        largura: [50, 50],
        comprimento: [70, 70],
        altura: [165, 170],
      },
      {
        size: "G",
        largura: [52.5, 52.5],
        comprimento: [73.5, 73.5],
        altura: [170, 175],
      },
      {
        size: "GG",
        largura: [55, 55],
        comprimento: [77, 77],
        altura: [175, 178],
      },
      {
        size: "2XL",
        largura: [57, 57],
        comprimento: [80, 80],
        altura: [179, 184],
      },
    ],
  },
  treino: {
    label: "Kit Treino",
    icon: "🏃‍♂️",
    data: [
      {
        size: "S",
        comprimento: [69, 69],
        largura: [100, 100],
        peso: [98.5, 98.5],
        altura: [155, 170],
      },
      {
        size: "M",
        comprimento: [71, 71],
        largura: [104, 104],
        peso: [101, 101],
        altura: [165, 175],
      },
      {
        size: "L",
        comprimento: [73, 73],
        largura: [108, 108],
        peso: [103.5, 103.5],
        altura: [170, 185],
      },
      {
        size: "XL",
        comprimento: [75, 75],
        largura: [112, 112],
        peso: [106, 106],
        altura: [180, 195],
      },
      {
        size: "2XL",
        comprimento: [77, 77],
        largura: [116, 116],
        peso: [108.5, 108.5],
        altura: [195, 210],
      },
    ],
  },
};
